var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandMarkKnockout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "bmk-title"
  }, "Learn Microbes brand mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "bmk-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "bmk-desc"
  }, "Clinical notebook mark with the letters LM for Learn Microbes.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 32) scale(1.42) translate(-28.5 -32.5)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13h22.5L48 20.5V47a5 5 0 0 1-5 5H18a5 5 0 0 1-5-5V18a5 5 0 0 1 5-5z",
    stroke: "#ffffff",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 13v7.5H48",
    stroke: "#ffffff",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 22h-4M13 30h-4M13 38h-4M13 46h-4",
    stroke: "#ffffff",
    strokeWidth: 2.2,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 40.5h22",
    stroke: "#ffffff",
    strokeWidth: 1.7,
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("text", {
    x: 30.5,
    y: 31,
    textAnchor: "middle",
    dominantBaseline: "central",
    fill: "#ffffff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 16,
    letterSpacing: -0.5
  }, "LM"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandMarkKnockout);
export default __webpack_public_path__ + "static/media/brand-mark-knockout.603af3f8f7e97270ef7990528e96f52a.svg";
export { ForwardRef as ReactComponent };